import { useGetCardHolders as useGetCardHoldersQuery } from '@xhype/card-app-sdk';
import { useAuthStore } from '@package/smart-wallet/store';

export const useGetCardHolderData = () => {
  const id = useAuthStore((store) => store.id);

  /* Queries */
  const {
    data: cardHolderInfo,
    isLoading,
    isError,
    error,
    refetch,
  } = useGetCardHoldersQuery({
    enabled: !!id,
    userId: id ?? 0,
  });

  /* Return */
  return {
    isLoading,
    cardHolderInfo,
    isError,
    error,
    refetch,
  };
};
